module.exports = __webpack_public_path__ + "statics/img/3-4.9d29761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/3-4.png
// module id = GqlO
// module chunks = 1